import Grid from '@mui/material/Grid';
import { memo, ReactElement } from 'react';
import { useFormContext } from 'react-hook-form';

import Checkbox from '~/ui/components/inputs/Checkbox';
import Select from '~/ui/components/inputs/SelectWithoutAnimation';
import { IOption } from '~/types';

interface IProps {
  clientNoShow: boolean;
  noShowReasons: IOption[];
  isEdit?: boolean;
}

const ClientNoShowFields = ({ clientNoShow, noShowReasons, isEdit }: IProps): ReactElement => {
  const {
    control,
    formState: { errors },
  } = useFormContext();

  return (
    <Grid
      container
      size={{
        sm: 9,
      }}
    >
      <Grid
        size={{
          sm: 12,
        }}
      >
        <Checkbox
          control={control}
          errors={errors}
          name="clientNoShow"
          label="Client No Show"
          disabled={!isEdit}
        />
      </Grid>
      {clientNoShow && (
        <Grid
          size={{
            sm: 12,
          }}
        >
          <Select
            control={control}
            errors={errors}
            name="noShowReason"
            label="No Show Reasons"
            options={noShowReasons}
            hideSelectedOptions={false}
            openMenuOnFocus
          />
        </Grid>
      )}
    </Grid>
  );
};

export default memo(ClientNoShowFields);
